module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/mv_maedori_03-e605099460a4fac2628f1b0104f72f3d.webp";